import { render } from "./Complete.vue?vue&type=template&id=601d87c1"
import script from "./Complete.vue?vue&type=script&lang=ts"
export * from "./Complete.vue?vue&type=script&lang=ts"
script.render = render

export default script